// extracted by mini-css-extract-plugin
module.exports = {"loaderOverlay":"OverlayLoader_loaderOverlay__7scPT","loader":"OverlayLoader_loader__rR7L9","spin":"OverlayLoader_spin___qaqk"};